<div class="container-background container-fluid content pb-5" (window:resize)="onResize()">
  <ul class="nav nav-tabs mt-2" *ngIf="showNavBar">
    <a class="nav-link nav-item active">Suivi</a>
    <a class="nav-link nav-item" routerLink="/comparaison">Comparaison</a>
  </ul>

  <div class="row">
    <h2 class="page-title col-12">Suivi des consommations en kWh
      <div class="float-end" id="menu">
        <button *ngIf="logement?.canRT2012Repartition()" class="btn btn-light btn-lg btn-circle" (click)="modalService.open(modalParametrageDesUsages, {size: 'lg'})" title="Paramétrage des usages" matomoClickCategory="Consommations" matomoClickAction="click" matomoClickName="conso_parametres">
          <fa-icon [icon]="faCog"></fa-icon>
        </button>
        <button *ngIf="logement?.canRT2012Repartition()" class="btn btn-blue btn-lg btn-circle d-sm-none" (click)="modalService.open(modalAjoutReleve, {size: 'lg'})">
          <fa-icon [icon]="faPlus"></fa-icon>
        </button>
        <button *ngIf="logement?.canRT2012Repartition() && energiesEditables?.length" class="btn btn-blue d-none d-sm-inline-block btn-text" (click)="modalService.open(modalAjoutReleve, {size: 'lg'})" [disabled]="!logement?.parametrageRt2012IsComplet" matomoClickCategory="Consommations" matomoClickAction="click" matomoClickName="conso_ajouter_releve">
          <fa-icon [icon]="faPlus"></fa-icon><span> Ajouter un relevé</span>
          <ng-container *ngIf="(relevesIndividuels?.length === 0 ) && null !== user && (!hasEnedisAccessToken || !hasGazparAccessToken)">
            <img id="help-arrow" src="/assets-front/images/arrow_right.svg" alt="flêche droite" class="d-none d-sm-none d-md-inline-block" [@rubberBandOnEnter]>
          </ng-container>
        </button>
      </div>
    </h2>
  </div>
  <div class="m-2 p-4 bg-white rounded">
    <div class="row" *ngIf="logement?.isOpen() && !logement?.parametrageRt2012IsComplet">
      <div class="alert alert-warning">
        Le paramétrage de votre outil de suivi des consommations est incomplet. Il ne permet pas de calculer la
        répartition de vos consommations en cinq postes car il manque les informations relatives aux consommations
        collectives : rapprochez-vous de votre syndic ou des membres du conseil syndical.
        <ul>
          <li *ngFor="let field of logement?.parametrageRt2012IncompletFields">
            {{ field }}
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <section class="col-md-8">
        <h4>Répartition de vos données de consommation</h4>
        <div class="clearfix"></div>

        <ng-container *ngIf="logement?.canRT2012Repartition() || (energiesAvailables?.length || this.hasEnedisAccessToken || this.hasGazparAccessToken)">
          <div class="d-flex flex-column flex-lg-row justify-content-start">
            <div class="mb-3">
              <div class="d-flex align-items-start">
                <label for="dateFromPeriodPicker" class="col-form-label ps-2 pe-1">Du:</label>
                <div class="flex-grow-1">
                  <div class="input-group" #fromDateGroup>
                    <input id="dateFromPeriodPicker"
                           type="hidden"
                           name="dateFromPeriodPicker"
                           placeholder="dd/mm/YYYY"
                           [(ngModel)]="fromDate"
                           ngbDatepicker
                           (dateSelect)="onDateSelection($event)"
                           [startDate]="fromDate!"
                           [maxDate]="maxDate"
                           outsideDays="collapsed"
                           [positionTarget]="fromDateGroup"
                           #datepickerFromDate="ngbDatepicker" />
                    <input class="input-period-date form-control" [value]="fromDate | ngbDateToIso | date" />
                    <button class="btn btn-outline-secondary" (click)="datepickerFromDate.toggle()" type="button">
                      <fa-icon [icon]="faCalendar"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="d-flex align-items-start">
                <label for="dateToPeriodPicker" class="col-form-label ps-2 pe-1">Au:</label>
                <div class="flex-grow-1">
                  <div class="input-group" #toDateGroup>
                    <input id="dateToPeriodPicker"
                           type="hidden"
                           name="dateToPeriodPicker"
                           placeholder="yyyy-mm-dd"
                           [(ngModel)]="toDate"
                           ngbDatepicker
                           [value]="toDate | ngbDateToIso | date"
                           (dateSelect)="onDateSelection($event)"
                           [startDate]="toDate!"
                           [maxDate]="maxDate"
                           outsideDays="collapsed"
                           [positionTarget]="toDateGroup"
                           #datepickerToDate="ngbDatepicker">
                    <input class="input-period-date form-control" [value]="toDate | ngbDateToIso | date" />
                    <button class="btn btn-outline-secondary" (click)="datepickerToDate.toggle()" type="button">
                      <fa-icon [icon]="faCalendar"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ng-container>
            <div class="text-center">
              <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-secondary"
                        [ngClass]="{'active': grapheType === GrapheTypeEnum.ANNEE}"
                        (click)="switchGrapheType(GrapheTypeEnum.ANNEE)">
                  Année
                </button>
                <button type="button"
                        class="btn btn-secondary"
                        [ngClass]="{'active': grapheType === GrapheTypeEnum.MOIS}"
                        (click)="switchGrapheType(GrapheTypeEnum.MOIS)">
                  Mois
                </button>
                <button type="button"
                        class="btn btn-secondary"
                        [ngClass]="{'active': grapheType === GrapheTypeEnum.JOUR}"
                        (click)="switchGrapheType(GrapheTypeEnum.JOUR)">
                  Jour
                </button>
              </div>
            </div>
          </ng-container>

        </ng-container>

        <div id="graph">
          <ng-container *ngIf="(selectedVueMode === VueModeEnum.PAR_POSTE && synthesesPosteDeConsommation?.length > 0) || (selectedVueMode === VueModeEnum.PAR_ENERGIE && displayedConsommations?.length > 0)">
            <div class="graph-wrapper">
              <ngx-charts-bar-vertical-stacked
                [customColors]="customColors"
                [results]="selectedVueMode === VueModeEnum.PAR_POSTE ? displayedSynthesePostesDeConsommations : displayedConsommations"
                [gradient]="false"
                [xAxis]="true"
                [yAxis]="true"
                [animations]="true"
                [tooltipDisabled]="barTooltipDisabled"
                (select)="onClickOnBar($event)"
              >
                <ng-container *ngIf="selectedVueMode === VueModeEnum.PAR_ENERGIE">
                  <ng-template #tooltipTemplate let-model="model">
                    <div>{{ model.name }}</div>
                    <div>{{ model.value | number:'1.0-2' }} {{ selectedEnergie | energieUnit }}</div>
                  </ng-template>
                </ng-container>

                <ng-container *ngIf="selectedVueMode === VueModeEnum.PAR_POSTE">
                  <ng-template #tooltipTemplate let-model="model">
                    <div class="tooltip-wrapper">
                      <span class="date">{{ model.series }} (KWh):</span>
                      <ul>
                        <li *ngIf="getPosteDeConsoValeurForSerie(model.series, 'Chauffage') > 0" [class.active]="model.name === 'Chauffage'">
                          <div class="puce" [style]="{'background-color':SynthesePostesConsommation.CONSOMMATION_CHAUFFAGE_COLOR}"></div>
                          <span class="label">Chauffage : </span>
                          <span class="value">{{ getPosteDeConsoValeurForSerie(model.series, 'Chauffage') }}</span>
                        </li>
                        <li *ngIf="getPosteDeConsoValeurForSerie(model.series, 'Refroidissement') > 0" [class.active]="model.name === 'Refroidissement'">
                          <div class="puce" [style]="{'background-color':SynthesePostesConsommation.CONSOMMATION_REFROIDISSEMENT_COLOR}"></div>
                          <span class="label">Reffroidissement : </span>
                          <span class="value">{{ getPosteDeConsoValeurForSerie(model.series, 'Refroidissement') }}</span>
                        </li>
                        <li *ngIf="getPosteDeConsoValeurForSerie(model.series, 'ECS') > 0" [class.active]="model.name === 'ECS'">
                          <div class="puce" [style]="{'background-color':SynthesePostesConsommation.CONSOMMATION_ECS_COLOR}"></div>
                          <span class="label">Eau chaude sanitaire : </span>
                          <span class="value">{{ getPosteDeConsoValeurForSerie(model.series, 'ECS') }}</span>
                        </li>
                        <li *ngIf="getPosteDeConsoValeurForSerie(model.series, 'Prises électriques') > 0" [class.active]="model.name === 'Prises électriques'">
                          <div class="puce" [style]="{'background-color':SynthesePostesConsommation.CONSOMMATION_PRISES_ELEC_COLOR}"></div>
                          <span class="label">Prises électriques : </span>
                          <span class="value">{{ getPosteDeConsoValeurForSerie(model.series, 'Prises électriques') }}</span>
                        </li>
                        <li *ngIf="getPosteDeConsoValeurForSerie(model.series, 'Autres') > 0" [class.active]="model.name === 'Autres'">
                          <div class="puce" [style]="{'background-color':SynthesePostesConsommation.CONSOMMATION_AUTRES_COLOR}"></div>
                          <span class="label">Autres appareils : </span>
                          <span class="value">{{ getPosteDeConsoValeurForSerie(model.series, 'Autres') }}</span>
                        </li>
                      </ul>
                    </div>
                  </ng-template>
                </ng-container>

              </ngx-charts-bar-vertical-stacked>
            </div>
          </ng-container>
          <div class="offset-md-2 messages" *ngIf="errorMessages">
            <span class="color-saumon" *ngFor="let message of errorMessages">{{message}}</span>
          </div>
          <div class="offset-md-2 messages" *ngIf="selectedVueMode === VueModeEnum.PAR_ENERGIE || displayedSynthesePostesDeConsommations === null">
            <span *ngIf="displayedConsommations === null">Chargement des données de consommation en cours ...</span>
            <span *ngIf="!hasGazparAccessToken && !hasEnedisAccessToken && displayedConsommations !== null && consommations?.length && relevesIndividuels.length === 0">Aucune donnée de consommation n'a été trouvée pour cette période. <span class="color-saumon">Avez-vous ajouté un relevé ?</span></span>
            <span *ngIf="!hasGazparAccessToken && !hasEnedisAccessToken && displayedConsommations !== null && consommations?.length === 0 && relevesIndividuels.length === 1">Vous n'avez ajouté qu'un seul relevé pour la période sélectionnée. <span class="color-saumon">La saisie d'un deuxième relevé est nécessaire pour visualiser l'évolution de vos données de consommation.</span></span>
          </div>
          <div class="clearfix"></div>
        </div>
        <div id="mobile-values" #mobileValues *ngIf="barTooltipDisabled && activeBarLegend != null">
          <ng-container *ngIf="selectedVueMode === VueModeEnum.PAR_POSTE">
            <div class="tooltip-wrapper">
              <span class="date">{{ activeBarLegend.series | ucfirst }} (KWh):</span>
              <ul>
                <li *ngIf="getPosteDeConsoValeurForSerie(activeBarLegend.series, 'Chauffage') > 0" [class.active]="activeBarLegend.name === 'Chauffage'">
                  <div class="puce" [style]="{'background-color':SynthesePostesConsommation.CONSOMMATION_CHAUFFAGE_COLOR}"></div>
                  <span class="label">Chauffage : </span>
                  <span class="value">{{ getPosteDeConsoValeurForSerie(activeBarLegend.series, 'Chauffage') }}</span>
                </li>
                <li *ngIf="getPosteDeConsoValeurForSerie(activeBarLegend.series, 'Refroidissement') > 0" [class.active]="activeBarLegend.name === 'Refroidissement'">
                  <div class="puce" [style]="{'background-color':SynthesePostesConsommation.CONSOMMATION_REFROIDISSEMENT_COLOR}"></div>
                  <span class="label">Reffroidissement : </span>
                  <span class="value">{{ getPosteDeConsoValeurForSerie(activeBarLegend.series, 'Refroidissement') }}</span>
                </li>
                <li *ngIf="getPosteDeConsoValeurForSerie(activeBarLegend.series, 'ECS') > 0" [class.active]="activeBarLegend.name === 'ECS'">
                  <div class="puce" [style]="{'background-color':SynthesePostesConsommation.CONSOMMATION_ECS_COLOR}"></div>
                  <span class="label">Eau chaude sanitaire : </span>
                  <span class="value">{{ getPosteDeConsoValeurForSerie(activeBarLegend.series, 'ECS') }}</span>
                </li>
                <li *ngIf="getPosteDeConsoValeurForSerie(activeBarLegend.series, 'Prises électriques') > 0" [class.active]="activeBarLegend.name === 'Prises électriques'">
                  <div class="puce" [style]="{'background-color':SynthesePostesConsommation.CONSOMMATION_PRISES_ELEC_COLOR}"></div>
                  <span class="label">Prises électriques : </span>
                  <span class="value">{{ getPosteDeConsoValeurForSerie(activeBarLegend.series, 'Prises électriques') }}</span>
                </li>
                <li *ngIf="getPosteDeConsoValeurForSerie(activeBarLegend.series, 'Autres') > 0" [class.active]="activeBarLegend.name === 'Autres'">
                  <div class="puce" [style]="{'background-color':SynthesePostesConsommation.CONSOMMATION_AUTRES_COLOR}"></div>
                  <span class="label">Autres appareils : </span>
                  <span class="value">{{ getPosteDeConsoValeurForSerie(activeBarLegend.series, 'Autres') }}</span>
                </li>
              </ul>
            </div>
          </ng-container>
          <ng-container *ngIf="selectedVueMode === VueModeEnum.PAR_ENERGIE">
            <div class="tooltip-wrapper">
              <span class="date">{{ activeBarLegend.series | ucfirst }}:</span>&nbsp;
              <span class="value">{{ activeBarLegend.value | number:'1.0-0'}}</span>&nbsp;
              <span class="unit" innerHTML="{{ EnergieEnum[activeBarLegend.label] | energieUnit}}"></span>
            </div>
          </ng-container>
        </div>
        <div id="controls">
          <div class="mb-3 row" *ngIf="logement?.canRT2012Repartition()">
            <legend class="col-form-label col-sm-2">Vue:</legend>
            <div class="col-sm-10">
              <label class="btn" [ngClass]="{ 'btn-blue active': selectedVueMode === VueModeEnum.PAR_POSTE, 'btn-light': selectedVueMode !== VueModeEnum.PAR_POSTE }">
                <input type="radio" name="vue-mode" autocomplete="off" (click)="switchVueMode(VueModeEnum.PAR_POSTE)" [checked]="selectedVueMode === VueModeEnum.PAR_POSTE" matomoClickCategory="Consommations" matomoClickAction="click" matomoClickName="conso_affichage_poste"> Par poste
              </label>
              <label class="btn" [ngClass]="{ 'btn-blue active': selectedVueMode === VueModeEnum.PAR_ENERGIE, 'btn-light': selectedVueMode !== VueModeEnum.PAR_ENERGIE }">
                <input type="radio" name="vue-mode" autocomplete="off" (click)="switchVueMode(VueModeEnum.PAR_ENERGIE)" [checked]="selectedVueMode === VueModeEnum.PAR_ENERGIE"  matomoClickCategory="Consommations" matomoClickAction="click" matomoClickName="conso_affichage_energie"> Par énergie
              </label>
            </div>
          </div>
          <div class="mb-3 row" *ngIf="(energiesAvailables?.length || this.hasEnedisAccessToken || this.hasGazparAccessToken) && selectedVueMode === VueModeEnum.PAR_ENERGIE">
            <label for="selectedEnergie" class="col-form-label col-sm-2">Énergie en kWh:</label>
            <div class="col-xs-10 col-md-5 col-lg-4 col-xl-3">
              <select class="form-control" id="selectedEnergie" [ngModel]="selectedEnergie" (ngModelChange)="updateSelectedEnergie($event)">
                <option *ngFor="let energie of energiesAvailables" [ngValue]="energie">{{ energie | energieName }}</option>
              </select>
            </div>
          </div>
        </div>
      </section>
      <section class="col-md-4" *ngIf="(displayCoolingActivityPeriods() || displayHeatingActivityPeriods() || (relevesIndividuels?.length > 0 || (null !== user && hasEnedisAccessToken || hasGazparAccessToken))) && loadingTerminate">
        <app-active-consumption-period
          (periodRefreshed)="onPeriodAdded()"
          *ngIf="displayCoolingActivityPeriods()"
          [logement]="logement"
          [energy]="EnergieEnum.REFROIDISSEMENT"
          [activeConsumptionPeriods]="coolingActiveConsumptionPeriods"></app-active-consumption-period>
        <app-active-consumption-period
          (periodRefreshed)="onPeriodAdded()"
          *ngIf="displayHeatingActivityPeriods()"
          [logement]="logement"
          [energy]="EnergieEnum.CHAUFFAGE"
          [activeConsumptionPeriods]="heatingActiveConsumptionPeriods"></app-active-consumption-period>
        <app-historique-releve *ngIf="relevesIndividuels?.length > 0" [relevesIndividuels]="relevesIndividuels" [isEditable]="$safeNavigationMigration(logement?.isOpen())" (releveDeleted)="reloadRelevesEtConsos()" (releveUpdated)="reloadRelevesEtConsos()"></app-historique-releve>
        <div *ngIf="null !== user && (hasEnedisAccessToken || hasGazparAccessToken)">
          <h4>Connecté à :</h4>
          <div *ngIf="hasEnedisAccessToken">
            <div class="row mt-3">
              <div class="col-3 col-centered">
                <img class="w-100" src="assets-front/images/compteur-linky.png">
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="btn-linky-legende">
                  Vous avez donné votre consentement pour qu’Enedis nous transmette vos données.
                  Vous pouvez à tout moment demander l’annulation de cet accès à vos données en
                  contactant l’adresse <a href="mailto:dataconnect@enedis.fr">dataconnect&#64;enedis.fr</a>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center m-auto">
              <button class="btn btn-sm btn-orange" (click)="deleteEnedisToken()">
                Se déconnecter
              </button>
            </div>

          </div>
          <div *ngIf="hasGazparAccessToken">
            <div class="row mt-3">
              <div class="col-3 col-centered">
                <img class="w-100" src="assets-front/images/compteur-gazpar.png">
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="btn-linky-legende">
                  Vous avez donné votre consentement pour que GRDF nous transmette vos données.
                  Vous pouvez à tout moment demander d'annuler ce partage de données en supprimant
                  votre droit d'accès directement sur
                  <a href="https://monespace.grdf.fr/monespace/connexion">mon compte personnel GRDF</a>.
                </div>
              </div>
              <div class="d-flex justify-content-center m-auto">
                <button class="btn btn-sm btn-orange" (click)="deleteGazparToken()">
                  Se déconnecter
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ng-container *ngIf="logement?.statut !== 'FERME'">
        <div class="row w-100" *ngIf="null !== user && !hasEnedisAccessToken && loadingTerminate" matomoClickCategory="Consommations" matomoClickAction="click" matomoClickName="conso_lien_linky">
          <div class="offset-4 col-4 d-flex justify-content-center">
            <div class="d-flex align-items-center m-auto">
              <span class="d-none d-sm-block ms-3 h5 me-3">Données Linky</span><br>
              <button class="btn btn-linky d-sm-inline-block" (click)="getFromLinky()" >
                <img src="assets-front/images/vert-enedis.png">
              </button>
            </div>
          </div>
          <div class="col-2">
            <ng-container>
              <img id="help-arrow-enedis" src="/assets-front/images/arrow_right.svg" alt="flêche droite" class="d-none d-sm-none d-md-inline-block" [@rubberBandOnEnter]>
            </ng-container>
          </div>
          <div class="col-12 d-flex justify-content-center">
            <div class="d-flex align-items-center m-auto btn-linky-legende">
              <div>En cliquant sur ce bouton, vous allez accéder à votre compte personnel Enedis où vous pourrez donner votre accord pour qu’Enedis nous transmette vos données.</div>
            </div>
          </div>
        </div>
        <div class="row w-100 mt-3" *ngIf="null !== user && !hasGazparAccessToken && loadingTerminate &&(energiesEditables.includes(EnergieEnum.GAZ) || logement.getNatureChauffage() == EnergieEnum.GAZ || logement.getNatureEauChaude() == EnergieEnum.GAZ)">
          <div class="offset-4 col-4 d-flex justify-content-center">
            <div class="d-flex align-items-center m-auto">
              <span class="d-none d-sm-block ms-3 h5 me-3">Données Gazpar</span><br>
              <button class="btn btn-linky d-sm-inline-block" (click)="getFromGazpar()" >
                <img src="assets-front/images/vert-gazpar.png" style="height: 56px">
              </button>
            </div>
          </div>
          <div class="col-2">
            <ng-container>
              <img id="help-arrow-gazpar" src="/assets-front/images/arrow_right.svg" alt="flêche droite" class="d-none d-sm-none d-md-inline-block" [@rubberBandOnEnter]>
            </ng-container>
          </div>
          <div class="col-12 d-flex justify-content-center">
            <div class="d-flex align-items-center m-auto btn-linky-legende">
              <div>En cliquant sur ce bouton, vous allez accéder à votre compte personnel GRDF où vous pourrez donner votre accord pour que GRDF nous transmette vos données.</div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #modalAjoutReleve>
  <div class="modal-body">
    <app-edit-releve [logement]="logement" (releveAdded)="onReleveAdded($event)" [relevesIndividuels]="relevesIndividuels"></app-edit-releve>
  </div>
</ng-template>

<ng-template #modalUsagePointId>
  <div class="modal-body">
    <app-usage-point-selector [logement]="logement" [usagePoints]="usagePoints" [gazparUsagePoints]="gazparUsagePoints" (usagePointSelected)="usagePointSelected($event)"></app-usage-point-selector>
  </div>
</ng-template>

<ng-template #modalParametrageDesUsages>
  <div class="modal-body">
    <app-parametrage-usages [logement]="logement" (usageOccupantUpdated)="onUsageOccupantUpdated($event)"></app-parametrage-usages>
  </div>
</ng-template>
